import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";

import { useAuthStore } from "@companion-core/shared/app/Store/authStore";
import { getModule } from "@companion-core/shared/app/Utils/config";
import { useMemberData } from "@companion-core/shared/app/Hooks/member";

const ONBOARDING_PATH = "/onboarding";

const OnboardingGuard = () => {
  const { pathname } = useLocation();
  const authenticated = useAuthStore((state) => state.authenticated);
  const onboardingHasAppeared = useAuthStore((state) => state.onboardingHasAppeared);
  const setOnboardingHasAppeared = useAuthStore((state) => state.setOnboardingHasAppeared);
  const { data: member, isPending } = useMemberData();
  const isEnabled = !!getModule("onboarding")?.enabled;
  const isOnboardingPath = pathname === ONBOARDING_PATH;

  const shouldRedirect =
    isEnabled &&
    !!member &&
    !member.last_onboarding_date &&
    !onboardingHasAppeared &&
    !isOnboardingPath;

  useEffect(() => {
    if (isOnboardingPath && isEnabled && !onboardingHasAppeared) {
      setOnboardingHasAppeared(true);
    }
  }, [isOnboardingPath, isEnabled, onboardingHasAppeared, setOnboardingHasAppeared]);

  if (authenticated && isPending) {
    return <Outlet />;
  }

  if (shouldRedirect) {
    return <Navigate to={ONBOARDING_PATH} replace />;
  }

  return <Outlet />;
};

export default OnboardingGuard;
